import { listen, qs, add, contains } from '@fluorescent/dom';

const selectors = {
  badgeText: '[data-review-caption]',
  reviewsSection: '#shopify-product-reviews',
};

export default function () {
  const reviewsBadgeText = qs(selectors.badgeText, document);
  const reviewsSection = qs(selectors.reviewsSection, document);

  if (!reviewsBadgeText || !reviewsSection) return;

  const button = document.createElement('button');
  button.classList.add('reviews__anchor-trigger');
  add(reviewsBadgeText, 'btn', 'btn--text-link');

  reviewsBadgeText.parentNode.insertBefore(button, reviewsBadgeText);
  button.appendChild(reviewsBadgeText);

  button.tabIndex = '0';

  listen(button, 'click', e => {
    e.preventDefault();
    const headerOffsetVar = contains(document.body, 'header-sticky')
      ? getComputedStyle(document.documentElement).getPropertyValue(
          '--height-header'
        )
      : 0;
    const offset = parseInt(headerOffsetVar, 10);
    const y =
      reviewsSection.getBoundingClientRect().top + window.pageYOffset - offset;
    window.scrollTo({ top: y, behavior: 'smooth' });
  });
}
